export default function clearFilter() {
  Object.keys({ ...localStorage }).forEach((key) => {
    ['sort', 'filter', 'pagesize', 'pageindex'].forEach((value) => {
      if (key.toLowerCase().includes(value)) {
        localStorage.removeItem(key);
      }
    })
  });
}
